import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=5345b6a0&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=5345b6a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5345b6a0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/side-bar/Menu.vue
// module id = 904
// module chunks = 0